export const updateIntercomSettings = (changes) => {
  window.intercomSettings = Object.assign({}, window.intercomSettings, changes);

  window.Intercom('update');
};

export default {
  updateIntercomSettings,
};
